import { useEffect } from 'react';
import { notification } from 'antd';
import { _setNotificationInstance } from './index';

// Mount this component inside antd's <App> wrapper so useApp() has theme context.
// It registers the antd notification instance into the bridge store.
export default function NotificationBridge() {
    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        _setNotificationInstance(api);
        return () => _setNotificationInstance(null);
    }, [api]);

    return contextHolder;
}